import { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { ArrowRight, ExternalLink } from "lucide-react";
import { scrollToId, ease, openCalendly } from "./utils";

export default function StickyCTA() {
  const reduce = useReducedMotion();
  const [heroVisible, setHeroVisible] = useState(true);
  const [finalVisible, setFinalVisible] = useState(false);

  useEffect(() => {
    const hero = document.querySelector("[data-testid='hero-section']");
    const final = document.querySelector("[data-testid='final-cta-section']");
    const observers = [];

    if (hero) {
      const o = new IntersectionObserver(([e]) => setHeroVisible(e.isIntersecting), { threshold: 0 });
      o.observe(hero);
      observers.push(o);
    }
    if (final) {
      const o = new IntersectionObserver(([e]) => setFinalVisible(e.isIntersecting), { threshold: 0.05 });
      o.observe(final);
      observers.push(o);
    }
    return () => observers.forEach((o) => o.disconnect());
  }, []);

  const show = !heroVisible && !finalVisible;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="sticky-cta-bar"
          role="region"
          aria-label="Quick actions"
          initial={{ opacity: 0, y: reduce ? 0 : 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: reduce ? 0 : 24 }}
          transition={{ duration: 0.5, ease }}
          className="fixed bottom-3 left-1/2 z-40 w-[calc(100%-1.5rem)] max-w-[680px] -translate-x-1/2 sm:bottom-5"
        >
          <div className="flex items-center justify-between gap-3 rounded-2xl border border-brand-gold/30 bg-brand-black/80 px-3.5 py-3 shadow-[0_18px_50px_-12px_rgba(0,0,0,0.6)] backdrop-blur-xl sm:rounded-full sm:gap-5 sm:px-6 sm:py-3.5">
            <p className="hidden font-sans text-sm font-medium text-white/85 md:block">
              Ready to find your next revenue opportunity?
            </p>

            <div className="flex w-full items-center gap-2.5 sm:w-auto">
              <button
                data-testid="sticky-book-call"
                aria-label="Book a free call — opens scheduling in a new tab"
                onClick={openCalendly}
                className="group inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-gradient-to-br from-brand-gold to-brand-gold-deep px-5 py-3 font-sans text-sm font-semibold tracking-wide text-brand-black transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_14px_34px_-10px_rgba(200,154,61,0.7)] sm:flex-none"
              >
                Book a Free Call
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
              </button>

              <a
                data-testid="sticky-client-portal"
                aria-label="Client portal — scroll to booking section"
                href="#final-cta"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToId("final-cta");
                }}
                className="group inline-flex flex-1 items-center justify-center gap-2 rounded-full border border-brand-gold/40 bg-white/5 px-5 py-3 font-sans text-sm font-semibold tracking-wide text-white transition-all duration-300 hover:-translate-y-0.5 hover:border-brand-gold hover:bg-white/10 sm:flex-none"
              >
                Client Portal
                <ExternalLink className="h-3.5 w-3.5 text-brand-gold" />
              </a>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
